export default __webpack_public_path__ + "static/media/arrow.d1e57e27.svg";